<script>
export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="empty-state py-16 px-1">
    <h3
      v-if="title"
      class="block w-full text-xl font-thin text-center text-body"
    >
      {{ title }}
    </h3>
    <p
      v-if="message"
      class="block w-[90%] mx-auto my-4 text-center text-subtle"
    >
      {{ message }}
    </p>
    <slot />
  </div>
</template>
